// In-memory access token (never persisted). Auth transport is the HttpOnly
// cookie set by the backend; this copy only feeds the Echo channel-auth header.
// Lost on reload; the silent refresh in permission.ts restores the session.
let accessToken: string | null = null

export const tokenStore = {
  get: (): string | null => accessToken,
  set: (token: string): void => {
    accessToken = token
  },
  clear: (): void => {
    accessToken = null
  }
}
